import { createFileRoute } from "@tanstack/react-router";
import { ExerciseResults } from "@/components/exercise-results";
import { useT } from "@/glossary";

export const Route = createFileRoute("/omo/results")({
  component: OmoResults,
});

function OmoResults() {
  const t = useT();
  return <ExerciseResults id="omo" againLabel={t.omo.challengeAgain} />;
}
